module.exports = __webpack_public_path__ + "static/media/walltittle3.70b894da.jpeg";